import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { versionApp } from 'src/environments/environment.prod';
import { MenuEntry, menuForRole } from 'src/app/data/Menu/event-menus';
import { EventAdminService } from 'src/app/services/event-admin/event-admin.service';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {

    @Input('page') active_page: any;
    @Input('changeSize') callbackFunction: (args: any) => void;

    @Input('hiden') hiden: Boolean;
    hiddenMenu: Boolean = true

    version = versionApp

    public appPages: MenuEntry[] = [];

    /** Eventos asignados al usuario, para mostrarlos bajo su correo. */
    my_events: { key: string; name: string }[] = [];
    events_loaded = false;

    constructor(
        public auth: AuthService,
        private eventAdmin: EventAdminService,
    ) {
        this.appPages = menuForRole(this.auth.role);
    }

    ngOnInit() {
        let root = document.getElementById("menu")
        if (root) {
            root.style.transition = 'width 0.10s';
        }
        this.loadMyEvents();
    }

    private async loadMyEvents() {
        try {
            this.my_events = await this.eventAdmin.getMyEvents();
        } catch (e) {
            console.warn('No se pudieron leer los eventos del usuario:', e);
            this.my_events = [];
        }
        this.events_loaded = true;
    }

    /** Un evento: su nombre. Varios: cuántos (los nombres van en el title). */
    get events_label(): string {
        if (!this.events_loaded) return '';
        if (this.my_events.length === 0) return 'Sin evento asignado';
        if (this.my_events.length === 1) return this.my_events[0].name;
        return `${this.my_events.length} eventos asignados`;
    }

    get events_title(): string {
        return this.my_events.map(e => e.name).join(' · ');
    }

    changeVisibility() {
        this.hiddenMenu = !this.hiddenMenu
        let root = document.getElementById("menu")
        if (root && this.callbackFunction) {
            this.callbackFunction(root)
        }
    }


    validateSegment(title: string): boolean {
        let url = window.location.href.split("#")
        return url[1] == title
    }

    /** auth.logOut() ya redirige a /login al completar el signOut. */
    logout() {
        this.auth.logOut();
    }
}
